import { useEffect, useRef, useState } from 'react'
import { useOverlayLifecycle } from '@/components/common/overlays/OverlayFoundation'

/** Whether the media query matches now, following it as the window changes. */
export function useMediaMatch(query) {
  const read = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches
  const [matches, setMatches] = useState(read)
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined
    const media = window.matchMedia(query)
    const update = () => setMatches(media.matches)
    update()
    media.addEventListener?.('change', update)
    return () => media.removeEventListener?.('change', update)
  }, [query])
  return matches
}

/**
 * A Surfaces side panel (#990): beside the cards from `inlineQuery` up, a
 * full-screen sheet below it. As a sheet it takes focus as the shared
 * drawers do (focus moves in, Tab stays in it, Escape closes it, focus goes
 * back to what opened it); the page behind it stays as it is, since the
 * panel lives in the page rather than an overlay portal.
 */
export function useLineupPanel({ inlineQuery, onClose }) {
  const ref = useRef(null)
  const inline = useMediaMatch(inlineQuery)
  useOverlayLifecycle({ open: !inline, onClose, dismissable: true, modal: false, trapFocus: true, surfaceRef: ref })
  return { ref, sheet: !inline }
}
